export type ProductError = {
  newLine?: string;
  sainId?: string;
  skuNumber?: string;
  catNumber?: string;
  unitOfMeasure?: string;
  description?: string;
  packSize?: string;
  outerLength?: string;
  outerWidth?: string;
  outerHeight?: string;
  outerWeight?: string;
  outerNetWeight?: string;
  innerLength?: string;
  innerWidth?: string;
  innerHeight?: string;
  innerWeight?: string;
  innerNetWeight?: string;
  ti?: string;
  hi?: string;
  merchandisingUnit?: string;
  conveyable?: string;
  twoPersonLift?: string;
  uglies?: string;
  ean?: string;
  tuc?: string;
  minimumLifeOnReceipt?: string;
  minimumLifeOnIssue?: string;
  breakPack?: string;
  hazardous?: string;
  hazardousCode?: string;
  multiPart?: string;
  productType?: string;
  familyGroup?: string;
  lifecycle?: string;
  activeDate?: string;
  nestedItem?: string;
  nestIncrement?: string | null;
  grabInBox?: string;
  measurementRequired?: string;
  validation?: string;
  company?: string;
  businessUnit?: string;
  businessUnitDesc?: string;
  superCategory?: string;
  category?: string;
  categoryDesc?: string;
  subCategory?: string;
  subCategoryDesc?: string;
  superCatDesc?: string;
  segment?: string;
  segmentDesc?: string;
  skuCount?: string;
  muType?: string;
  mlor?: string;
  mloi?: string;
  error?: string;
  oldFamilyGroup?: string;
  warehouseId?: string;
  id: string;
  createdDate?: string;
  updatedDate?: string;
  familyGroupWithDescription?: string;
  manual?: string;
  hasWarnings?: string;
  breakPackIndicator?: string;
  //isActive?: string;
  outerDimensions: OuterDimensionsError;
  innerDimensions: InnerDimensionsError;
  automationAdaptoSystem?: string | null;
  automationToteFill?: string | null;
  automationMinTotes?: string | null;
  highRisk?: string | null;
  strapTotes?: string | null;
  expiryDateRequired?: string | null;
  pickPack?: string | null;
};

export type OuterDimensionsError = {
  height?: string;
  heightUOM?: string;
  width?: string;
  widthUOM?: string;
  length?: string;
  lengthUOM?: string;
  weight?: string;
  weightUOM?: string;
  ti?: string;
  hi?: string;
  breakPackQty?: string;
};
export type InnerDimensionsError = {
  height?: string;
  heightUOM?: string;
  width?: string;
  widthUOM?: string;
  length?: string;
  lengthUOM?: string;
  weight?: string;
  weightUOM?: string;
  ti?: string;
  hi?: string;
};

export const productError: ProductError = {
  newLine: undefined,
  sainId: undefined,
  skuNumber: undefined,
  catNumber: undefined,
  unitOfMeasure: undefined,
  description: undefined,
  packSize: undefined,
  // outerLength: undefined,
  // outerWidth: undefined,
  // outerHeight: undefined,
  // outerWeight: undefined,
  // outerNetWeight: undefined,
  // innerLength: undefined,
  // innerWidth: undefined,
  // innerHeight: undefined,
  // innerWeight: undefined,
  // innerNetWeight: undefined,
  // ti: undefined,
  // hi: undefined,
  merchandisingUnit: undefined,
  conveyable: undefined,
  twoPersonLift: undefined,
  uglies: undefined,
  ean: undefined,
  minimumLifeOnReceipt: undefined,
  minimumLifeOnIssue: undefined,
  breakPack: undefined,
  hazardous: undefined,
  hazardousCode: undefined,
  multiPart: undefined,
  productType: undefined,
  familyGroup: undefined,
  lifecycle: undefined,
  activeDate: undefined,
  nestedItem: undefined,
  nestIncrement: null,
  grabInBox: undefined,
  measurementRequired: undefined,
  validation: undefined,
  company: undefined,
  businessUnit: undefined,
  businessUnitDesc: undefined,
  superCategory: undefined,
  category: undefined,
  categoryDesc: undefined,
  subCategory: undefined,
  subCategoryDesc: undefined,
  superCatDesc: undefined,
  segment: undefined,
  segmentDesc: undefined,
  skuCount: undefined,
  muType: undefined,
  mlor: undefined,
  mloi: undefined,
  error: undefined,
  oldFamilyGroup: undefined,
  warehouseId: undefined,
  id: "",
  createdDate: undefined,
  updatedDate: undefined,
  familyGroupWithDescription: undefined,
  manual: undefined,
  hasWarnings: undefined,
  breakPackIndicator: undefined,
  automationAdaptoSystem: null,
  automationToteFill: null,
  automationMinTotes: null,
  highRisk: undefined,
  strapTotes: undefined,
  expiryDateRequired: undefined,
  pickPack: undefined,
  //isActive: undefined,
  outerDimensions: {
    height: undefined,
    heightUOM: undefined,
    width: undefined,
    widthUOM: undefined,
    length: undefined,
    lengthUOM: undefined,
    weight: undefined,
    weightUOM: undefined,
    ti: undefined,
    hi: undefined,
    breakPackQty: undefined,
  },
  innerDimensions: {
    height: undefined,
    heightUOM: undefined,
    width: undefined,
    widthUOM: undefined,
    length: undefined,
    lengthUOM: undefined,
    weight: undefined,
    weightUOM: undefined,
    ti: undefined,
    hi: undefined,
  },
};
